import { getTranslation } from '@helpers/languageTranslations';
import { useTranslation } from '@stateManagement/TranslationContext';
import { SelectOption } from '@web-for-marketing/react-ui';
import { useMemo } from 'react';
import { LazyLoadedSelectOptionsTypes, useLazyLoadedSelectOptions } from './useLazyLoadedSelectOptions';
import { DropdownType } from '@models/customForm';

interface TitleFieldProps {
    id: string;
    name: string;
    label: string;
    placeholder: string;
}

const selectOptions: LazyLoadedSelectOptionsTypes[] = [DropdownType.Title];

export function useTitleDropdown(
    formValueTitle: string,
    isSalesforce?: boolean
): [boolean, TitleFieldProps, TitleFieldProps, SelectOption[]] {
    const { selectedLanguageTranslation } = useTranslation();
    const formTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formTranslations');
    }, [selectedLanguageTranslation]);
    const placeholderTranslations = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'formPlaceholders');
    }, [selectedLanguageTranslation]);
    const [titleOptions] = useLazyLoadedSelectOptions(selectOptions);

    const showUserTitle = formValueTitle === 'Other';

    const titleProps = {
        id: 'title',
        name: 'Title__c',
        label: formTranslations.title || 'Title',
        placeholder: placeholderTranslations.titlePlaceholder || 'Select a title\u2026',
    };

    const userTitleProps = {
        id: 'user_title',
        name: isSalesforce ? 'title' : 'Title',
        label: formTranslations.userTitle || 'Your title',
        placeholder: placeholderTranslations.userTitlePlaceholder || 'Enter a title\u2026',
    };

    return [showUserTitle, titleProps, userTitleProps, titleOptions];
}
